import React from 'react'

import {
  StyleSheet,
  ScrollView,
  View,
  Text
} from 'react-native'

import {
  adaptive, colors, typography,
} from '@sart/styles'
import {
  Space,
  MoonDial,
  BalanceItem
} from '@sart/components'
// import { prettyBytes } from '@sart/utilities'
import { useContent } from '@sart/content'
import client from '@sart/client'
import { Mobile } from '@sart/icons'

export default function PostpaidData(props) {
  // const { navigation } = props
  const content = useContent()

  const {
    cache: {
      postpaidBalances,
      contextService,
			language
    } = {}
  } = client

  function getBalanceQuantity(balances) {
    if (balances && balances.data && balances.data.quantity) {
      return balances.data.quantity
    }
    return 0
  }

  function getBalanceStartingQuantity(balances) {
    if(balances && balances.data && balances.data.startingQuantity) {
      return balances.data.startingQuantity
    }
    return 0
  }
  const UNITS = [
		'B',
		'KB',
		'MB',
		'GB',
		'TB',
		'PB',
		'EB',
		'ZB',
		'YB'
	];
  
  /*
  Formats the given number using `Number#toLocaleString`.
  - If locale is a string, the value is expected to be a locale-key (for example: `de`).
  - If locale is true, the system default locale is used for translation.
  - If no value for locale is specified, the number is returned unmodified.
  */
  const toLocaleString = (number, locale) => {
    let result = number;
    if (typeof locale === 'string') {
      result = number.toLocaleString(locale);
    } else if (locale === true) {
      result = number.toLocaleString();
    }
  
    return result;
  };

  function getConversionRateData(balances) {
    const conversionRates = balances.data.balanceDefinition.conversionRates
    const rate = conversionRates.filter(function (rate) {
      return rate.unit === 'GB'
    })
    return rate[0].rate
  }

  function formatBytes(value, balances, options) {
    if (!Number.isFinite(value)) {
      throw new TypeError(`Expected a finite number, got ${typeof value}: ${value}`);
    }
		
    options = Object.assign({}, options);
  
    if(value === 0) {
      return ' 0B';
    }
  
    const isNegative = value < 0;
    const prefix = isNegative ? '-' : '';
  
    if (isNegative) {
      return value;
    }
  
    if (value < 1) {
      const numberString = toLocaleString(value, options.locale);
      return prefix + numberString + 'B';
    }
  
    //const exponent = Math.min((Math.floor(Math.log10(value) / 3) + 4), UNITS.length - 1);
		const exponent = 3
    value = Number((value / getConversionRateData(balances)).toPrecision(2));
    const numberString = toLocaleString(value, options.locale);
    const unit = UNITS[exponent];
  
    return prefix + numberString + '' + unit;
  
  }
  
  return (
    <ScrollView
      style={styles.container}
    >
      <View style={styles.wrapper} >
				{contextService &&
					<View>
						<Space height={12} />
						<View style={styles.numberContainer}>
								<Mobile color={colors.srTextInput} height={26} width={11}/>
								<Space width={10} />
								<Text style={styles.numberText}>{contextService.lineIdentifier}</Text>
						</View>
						<Space height={12} />
					</View>
        }
        <View style={styles.dial}>
          <MoonDial
            name={content.dashboard.data}
            formatValue={val => formatBytes(val, postpaidBalances)}
            formatRange={val => formatBytes(val, postpaidBalances)}
            size={192}
            value={getBalanceQuantity(postpaidBalances)}
            range={getBalanceStartingQuantity(postpaidBalances)}
            style={styles.moondialStyle}
            strokeColour={colors.srGreen + 20}
            mostlyFullColour={colors.srDarkGreen}
            almostEmptyColour={colors.srGreen}
            mostlyFullTextColour={colors.srTextInput}
            almostEmptyTextColour={colors.srTextInput}
            textColour={styles.moondialTextStyle}
						injectedContent={content}
          />
        </View>
        <Space height={24} />

        {postpaidBalances.dataBreakdown && postpaidBalances.dataBreakdown.map((balance, i) =>
          <React.Fragment key={i}>
            <BalanceItem
              iconColor={colors.white}
              placeholderStyle={styles.balanceItem}
              balance={balance}
							language={language}
							injectedContent={content}
            />
            <Space height={24} />
          </React.Fragment>
        )}
      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 24,
    ...adaptive.wrapperPadding
  },
  wrapper: {
    paddingBottom:12
  },
  dial: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  moondialStyle: {
    ...typography.lightbold
  },
  balanceItem: {
    backgroundColor: colors.srGreen
  },
  moondialTextStyle: {
    ...typography.lightbold,
    color: colors.srTextInput
  },
  numberText: {
    textAlign: 'center',
    ...typography.extrabold,
    fontSize: 20
  },
	numberContainer: {
			flexDirection: 'row',
			justifyContent: 'center',
	}
})


